import React, { Component } from "react";
import { Route, NavLink, Routes } from "react-router-dom";
import { withRouter, RenderRoute } from "../../utils/router";
import { withRequest } from "../../utils/request";
import Loader from "../general/Loader";
import Edit from "./Edit";
import Ajustes from "./Ajustes";
import { getLink, permisions } from "../../utils/helpers";
import { ProductContext } from "./ProductContext";
import EditFotos from "./EditFotos";
import { auth } from "../../utils/auth";
import Compras from "./Compras";
import { gruposDeRespuesta } from "../../utils/categorias";
import { catalogoUnidadesCompleto } from "../../utils/unidades";

class Layout extends Component {
	state = {
		producto: {},
		loading: true,
		ubicaciones: [],
		almacenes: [],
		arbolGrupos: [],
		impuestos: [],
		unidades: [],
	};

	componentDidMount() {
		this.setState({
			loading: true,
		});
		Promise.all([
			this.getUnidades(),
			this.getImpuestos(),
			this.getArbolGrupos(),
			this.getTable("almacenes"),
			this.getTable("ubicaciones"),
			this.getProducto(),
		]).then(() => this.setState({ loading: false }));
	}

	getProducto = async (url = null) => {
		const id = this.props.match.params.id;
		url = url ? url : "productos/" + id;
		const producto = await this.props.request(url);

		if (producto.success) {
			this.setState({
				producto: producto.data,
			});
		}
	};

	getImpuestos = async (url = null) => {
		const id = this.props.match.params.id;
		url = url ? url : "impuestos-dropdown";
		const impuestos = await this.props.request(url);

		if (impuestos.success) {
			this.setState({
				impuestos: impuestos.data,
			});
		}
	};

	getArbolGrupos = async () => {
		const respuesta = await this.props.request("grupos?arbol=1");

		this.setState({ arbolGrupos: gruposDeRespuesta(respuesta) });
	};

	getTable = async (url = null) => {
		const table = await this.props.request(url);

		if (table.data) {
			this.setState({
				[url]: table.data,
			});
		}
	};
	getUnidades = async () => {
		this.setState({ unidades: await catalogoUnidadesCompleto() });
	};
	handleInputChange = (value, field) => {
		this.setState((state) => ({
			...state,
			producto: { ...state.producto, [field]: value },
		}));
	};
	render() {
		const { loading, producto, ubicaciones, almacenes, arbolGrupos, impuestos, unidades } =
			this.state;

		if (loading) {
			return <Loader />;
		}

		return (
			<div>
				<div className="page-header">
                    <a href={getLink("/productos")}>« Volver a productos</a>
					<h1 className="page-title">
						{producto.referencia} - {producto.nombre}
					</h1>
				</div>
				<div className="row layout-con-menu">
					<div className="col-md-3 col-lg-2 page-sidebar">
						<ul className="list-unstyled page-sidebar__menu">
							<li>
								<NavLink
									to={getLink(
										`/productos/${producto.id}/informacion`
									)}
									end
									className="nav-link"
								>
									Información General
								</NavLink>
							</li>
							{auth.canEdit(permisions.editarProductos) && (
								<li>
									<NavLink
										to={getLink(
											`/productos/${producto.id}/compras`
										)}
										end
										className="nav-link"
									>
										Compras
									</NavLink>
								</li>
							)}

							<li>
								<NavLink
									to={getLink(
										`/productos/${producto.id}/movimientos`
									)}
									end
									className="nav-link"
								>
									Movimientos
								</NavLink>
							</li>
							{producto.fotos && producto.tipo === "producto" && (
								<li>
									<NavLink
										to={getLink(
											`/productos/${producto.id}/fotos`
										)}
										end
										className="nav-link"
									>
										Fotos
									</NavLink>
								</li>
							)}
						</ul>
					</div>
					{ producto.id ? <div className="col-md pl-md-5">
						<Routes>
    						<Route
    							path='informacion'
    							element={<RenderRoute render={(props) => (
    								<ProductContext.Provider value={producto}>
    									<Edit
    										{...props}
    										producto={producto}
    										ubicaciones={ubicaciones}
    										almacenes={almacenes}
    										arbolGrupos={arbolGrupos}
    										recargarArbolGrupos={this.getArbolGrupos}
    										impuestos={impuestos}
    										unidades={unidades}
    										handleInputChange={
    											this.handleInputChange
    										}
    									/>
    								</ProductContext.Provider>
    							)} />}
    						/>
    						<Route
    							path='compras'
    							element={<RenderRoute render={(props) => (
    								<Compras {...props} producto={producto} />
    							)} />}
    						/>
    						<Route
    							path='fotos'
    							element={<RenderRoute render={(props) => (
    								<EditFotos
    									{...props}
    									producto={producto}
    									impuestos={impuestos}
    									handleInputChange={this.handleInputChange}
    								/>
    							)} />}
    						/>
    						<Route
    							path='movimientos'
    							element={<RenderRoute render={(props) => (
    								<Ajustes
    									{...props}
    									producto={producto}
    									getProducto={this.getProducto}
    								/>
    							)} />}
    						/>
						</Routes>
					</div> : <div className="col-md pl-md-5"> <Loader /> </div> }
				</div>
			</div>
		);
	}
}

export default withRouter(withRequest(Layout));
